import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { FilterPanel } from './FilterPanel';
import type { useProductFilters } from '../../hooks/useProductFilters';
type FilterApi = ReturnType<typeof useProductFilters>;
export function MobileFilterDrawer({
  open,
  onClose,
  api
}: {
  open: boolean;
  onClose: () => void;
  api: FilterApi;
}) {
  return <AnimatePresence data-id="element-557" data-mp="1rl9dpvrvhs5n">
      {open && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 z-50 bg-ink/40 lg:hidden" aria-hidden="true" data-id="element-558" data-mp="1rin5dtx5r8md" />
          <motion.div role="dialog" aria-modal="true" aria-label="Filters" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.28,
        ease: [0.32, 0.72, 0, 1]
      }} className="fixed left-0 top-0 z-50 flex h-full w-full max-w-sm flex-col bg-white lg:hidden" data-id="element-559" data-mp="1dnbbtpuqno71">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-560" data-mp="17og03h4i83yn">
              <h2 className="text-base font-bold text-ink" data-id="element-561" data-mp="ttchgzenderv">Filters</h2>
              <button type="button" onClick={onClose} aria-label="Close filters" className="flex h-9 w-9 items-center justify-center rounded-lg hover:bg-surface" data-id="element-562" data-mp="yqmep18a2uq9">
                <XIcon className="h-5 w-5" data-id="element-563" data-mp="1rf9x8p1n7604" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-5" data-id="element-564" data-mp="1cq59ytfzqbl5">
              <FilterPanel api={api} data-id="element-565" data-mp="1cplv5lln03bc" />
            </div>
            <div className="flex gap-3 border-t border-line p-4" data-id="element-566" data-mp="1ho6t1edf2awm">
              <button type="button" onClick={api.clearAll} className="h-11 flex-1 rounded-lg border border-line text-sm font-semibold text-ink" data-id="element-567" data-mp="25ejc9le43u2i">
                Clear
              </button>
              <button type="button" onClick={onClose} className="h-11 flex-[2] rounded-lg bg-ink text-sm font-semibold text-white" data-id="element-568" data-mp="2a72puicsup7b">
                Show {api.results.length} products
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}